import { useState, useCallback } from 'react';
import { useApi } from '../../../shared/hooks/useApi';
import { friendshipAPI, type Friend } from '../../../services/friendshipApi';

export function useFriends() {
  const [friends, setFriends] = useState<Friend[]>([]);
  
  const {
    execute: fetchFriends,
    isLoading,
    error
  } = useApi<Friend[]>(friendshipAPI.getFriends);
  
  const loadFriends = useCallback(async () => {
    const result = await fetchFriends();
    if (result) {
      setFriends(result);
    }
    return result;
  }, [fetchFriends]);
  
  const refreshFriends = useCallback(() => {
    return loadFriends();
  }, [loadFriends]);

  const {
    execute: removeFriendRequest,
    isLoading: isRemoving,
    error: removeError
  } = useApi<void>(friendshipAPI.removeFriend);

  const removeFriend = useCallback(async (friendshipId: string) => {
    const result = await removeFriendRequest(friendshipId);
    if (result !== undefined) {
      // Remove the friend from local state
      setFriends(prev => prev.filter(f => f.friendshipId !== friendshipId));
    }
    return result;
  }, [removeFriendRequest]);
  
  return {
    friends,
    isLoading,
    error,
    loadFriends,
    refreshFriends,
    setFriends,
    removeFriend,
    isRemoving,
    removeError
  };
}